module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("This book would not have been possible without the immeasurable contribution of my husband, Vaughn. His practical intuitiveness, technical proficiency, and unrelenting commitment to a deadline are the reasons you are able to hold this book in your hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("His engineering background has twice proved useful in my career as a crazy-quilt maker—with this book and previously in his contribution on my first book, "), _c('i', [_vm._v("Foolproof Crazy Quilting")]), _vm._v(". He manages to decipher the ideas and shapes in my head and translate them into patterns on paper that anyone who has never even picked up a needle before can use to create wonderful, crazy patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("I am also grateful to the many people who have come together to make this book happen.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("To Liz and the talented team at C&T Publishing, thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("To my friend and neighbor Jane, who donned many hats during my book-writing process—therapist, patient listener, quality controller, and a calming influence. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("To my children, Gareth and Ainslie, thank you for replying to my desperate calls for help regarding color choice and design.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("Lastly, to my students, who encourage, motivate, and stimulate me. You asked the question: “Have you started your next book?” My answer is, “Yes, I have, and here it is.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34244f80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_ack.vue
// module id = 66
// module chunks = 0